import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Tenders IEMs"/>
            
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">  
                        <h1>Independent External Monitors (IEMs)</h1>
                    </div> 
                    

                    <div className='row'>

                        <div className='col-md-6'>
                            <div className="border m-3">
                                    <div className='mt-3 ms-3'>
                                        <h4 className='mb-3'>Shri Aditya Prakash Mishra</h4>
                                        <ul className='myulcustarrow'>
                                            <li>Flat No.24, ASTER-1, Vatika City,<br />
                                                Sohna Road, Sector-49, Gurgaon-122003.<br />
                                                Email Id: apmishra53@gmail.com
                                            </li>
                                        </ul>
                                    </div>
                            </div> 
                        </div>
                        <div className='col-md-6'>
                            <div className="border m-3">
                                        <div className='mt-3 ms-3'>
                                            <h4 className='mb-3'>Shri Debal Kumar Gayen</h4>
                                            <ul className='myulcustarrow'>
                                                <li>Tower-5, Flat 5E, South City Garden,<br />
                                                    61.B.L.Saha Road, Kolkata-700053 (W.B).<br />
                                                    Email Id: gayen.dk@gmail.com
                                                </li>
                                            </ul>
                                        </div>
                                </div> 
                            </div>
                        </div>
                    </div>
            </section>
        </>
    )
}

export default Main;